import { render, staticRenderFns } from "./dadata.vue?vue&type=template&id=0b893575&scoped=true"
import script from "./dadata.vue?vue&type=script&lang=js"
export * from "./dadata.vue?vue&type=script&lang=js"
import style0 from "./dadata.vue?vue&type=style&index=0&id=0b893575&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b893575",
  null
  
)

export default component.exports